const config = {
  api: process.env.REACT_APP_API,
};

export const { api } = config;

export default config;
